import Vue, { createApp } from "vue"
import DynamicPropsFromAttr from '../../mixins/dynamic-props-from-attr'
import kebabCase from "kebab-case";
import VLazyImagePlugin from "vue3-lazyload"
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import filterInit from '../../utils/filters'

function initApp(app:Vue.Component, el:Element, useLazyImage:boolean = false) {
  const dynamicPropsFromAttr = {};
  for (let i = 0; i < el.attributes.length; ++i) {
    const attr = el.attributes[i];
    let attrName = attr.name;
    let attrValue : any = attr.value;
    if (attrName.indexOf('init-') >= 0) {
      // There's different use-cases for consumer. So, adding an extra prop here.
      if(!dynamicPropsFromAttr['isConsumer']){
        dynamicPropsFromAttr['isConsumer'] = true;
      }
      
      attrName = kebabCase.reverse(attrName.replace('init-', ''));
      if(!isNaN(parseInt(attrValue))){
        attrValue = parseInt(attrValue);
      }
      else if(attrValue.toLowerCase() == 'true' || attrValue.toLowerCase() == 'false'){
        attrValue = attrValue.toLowerCase() == 'true';
      }
      dynamicPropsFromAttr[attrName] = attrValue;
    }
  }

  const vueapp = createApp(app, dynamicPropsFromAttr);

  filterInit(vueapp);

  const options = {
    error: 'https://www.depositaccounts.com/content/logos/110x75/default.png',
    attempt: 1
  };

  vueapp.use(VLazyImagePlugin, options);
  vueapp.component('font-awesome-icon', FontAwesomeIcon);
  vueapp.mount(el);
}
export default initApp;